module.exports = __webpack_public_path__ + "static/img/xgyf2.18ff5a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/xgyf2.png
// module id = 395
// module chunks = 0